import React from 'react'
import { getChildrenOrHTMLProp } from '../../library/utils'

export default function Paragraph({x2, x3, x4, x5, children, className = '', ...attrs}) {
    const sizeClass = x2 ? 'text-lg' : x3 ? 'text-xl' : x4 ? 'text-2xl' : x5 ? 'text-4xl' : ''
    const childrenprop = getChildrenOrHTMLProp(children)
    
    return <p className={`${sizeClass} ${className}`} {...attrs} {...childrenprop}></p>
}